<template>
  <div class="main">
    <NavBar title="人工传话" left-arrow @click-left="onClickLeft"/>
    <NoticeBar
        left-icon="volume-o"
        text="请勿发送违规信息，否则将报警移交给相关公安机关处理，短信大概1-10分钟的延迟，22点-8点延迟时间较大，介意请在8点后发送信息。"
    />

    <Form class="form" @submit="submit">
      <CellGroup style="background-color: transparent;margin-top: 10px;display: flex;justify-content: space-between; align-items: center;" inset>
        <div>联系方式</div>
        <div style="color: #4295D7" @click="showZYSXTips = true">注意事项</div>
      </CellGroup>

      <CellGroup class="item" inset>
        <DropdownMenu style="flex:1;width:100%;">
          <DropdownItem
              style="margin:0 18px;"
              v-model="msgType"
              :options="msgTypeOptions"
              :title="selectedText"
          />
        </DropdownMenu>
      </CellGroup>

      <CellGroup class="item" inset>
        <Field v-model="accountInfo"
               placeholder="TA的社交账号"
               clearable
               :rules="[{ required: true, message: '请输入TA的社交账号' }]"/>
      </CellGroup>

      <CellGroup class="item" inset>
        <Field v-model="sendTime" @click="showTimePopup" placeholder="预约传话时间" right-icon="arrow" readonly
               :rules="[{ required: true, message: '请选择传话时间' }]"/>
        <Popup v-model:show="show" position="bottom">
          <DatetimePicker
              v-model="currentDate"
              type="datetime"
              title="请选择传话时间"
              :min-date="minDate"
              @cancel="show = false"
              @confirm="submitTime"
          />
        </Popup>
      </CellGroup>

      <CellGroup style="background-color: transparent;margin-top:10px;font-size:10px;color:#999" inset>
        <Icon name="info-o" color="#F7AF2F" style="margin-right:5px"/>
        选择了指定时间，我们将在指定时间的±1小时内送达，不保证100%准时
      </CellGroup>

      <CellGroup style="background-color: transparent;margin-top:10px;" inset>传话内容</CellGroup>
      <CellGroup class="item" inset>
        <Field
            v-model="smsContent"
            type="textarea"
            rows="6"
            :maxlength="maxLength"
            show-word-limit
            placeholder="点击输入传话内容（情感、表白、早晚安、道歉、 祝福…）禁止发送包含辱骂、破环他人关系等违规信息"
            class="sms-content"
            :rules="[{ required: true, message: '请填写传话内容' }]"
            clearable/>
      </CellGroup>

      <!-- 价格显示 -->
      <div class="sms-price-explain" v-if="msgType">
        人工传话价格：{{ currentPrice }}元每次
      </div>

      <CellGroup style="background-color: transparent;margin-top: 10px;" inset>备注</CellGroup>
      <CellGroup class="item" inset>
        <Field v-model="remark" type="textarea" rows="3" maxlength="300"
               placeholder="可以备注一些小要求(最多300字)，我们将在力所能及的情况下可以帮你完成。例如Ta的称呼、在线时间、在线习惯等"
               clearable/>
      </CellGroup>
      <CellGroup style="background-color: transparent;margin-top:10px;font-size:10px;color:#999" inset>
        <Icon name="info-o" color="#F7AF2F" style="margin-right:5px"/>
        如需传递照片、视频、文件等内容，请在首页联系客服微信
      </CellGroup>

      <div class="form-item anonymous-line">
        <Checkbox v-model="anonymous" checked-color="#00D477">匿名发送</Checkbox>
        <div v-if="!anonymous" class="van-hairline--bottom name-input">
          <Field class="name-input-field" v-model="name" placeholder="请输入你的称呼"/>
        </div>
      </div>

      <div class="center">
        <Button class="submit-btn" round block type="primary" color="#00D477" native-type="submit"
                @click="submitType='submit'">
          提交传话
        </Button>
      </div>
    </Form>

    <Popup v-model:show="previewSms" :style="{ height: '40%' }" style="background-color:#f7f7f7" closeable position="bottom">
      <div class="center-column">
        <div class="preview-date" style="color:#999">{{ previewDate }}</div>
        <div class="preview-box">
          <div class="preview-box-from">10691828543590</div>
          <div class="preview-box-item">{{ smsContent }}</div>
          <div class="preview-box-item" style="width:100%;text-align:right!important;">{{ name }}</div>
        </div>
      </div>
    </Popup>

    <BindPhoneDialog
        v-model:show="showBindPhoneDialog"
        :show-tips="true"
        @bind-success="handleBindSuccess"
        @close="handleBindClose"
    />

    <TermsDialog :visible="showTermsDialog" @confirm="showTermsDialog = false"/>

    <ActionSheet v-model:show="showZYSXTips" title="注意事项" :round="true">
      <div class="zysx-tips-content">
        <div class="zysx-item">
          <p class="zysx-question">1.多久可以传话完成?</p>
          <p class="zysx-desc">传话将在你选择“传话日期”内完成，如对方不同意好友，等其他原因导致无法传达到，将可以退款。</p>
        </div>
        <div class="zysx-item">
          <p class="zysx-question">2.怎么查看传话反馈?</p>
          <p class="zysx-desc">传话状态情况后可以在底部导航栏“传话”中查看反馈结果。</p>
        </div>
        <div class="zysx-item">
          <p class="zysx-question">3.可以传递音频和照片吗?</p>
          <p class="zysx-desc">如需传递音频照片视频等内容，请添加客服进行说明，并提供订单号。</p>
        </div>
      </div>
    </ActionSheet>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import {
  NavBar,
  Form,
  Field,
  CellGroup,
  Popup,
  DatetimePicker,
  Button,
  Checkbox,
  Toast,
  NoticeBar,
  DropdownMenu,
  DropdownItem,
  Icon,
  ActionSheet,
  Dialog
} from 'vant'
import TermsDialog from "@/components/TermsDialog.vue"
import BindPhoneDialog from "@/components/BindPhoneDialog.vue";
import dayjs from 'dayjs'
import { createMessengerOrder } from "../../api/order"
import { getMsgType } from "../../api/messenger"
import wx from "weixin-js-sdk"
import { getJsAPiSign, bindPhone, getCode, getUserInfo } from "../../api/user"

const router = useRouter()

const msgType = ref('')
const msgTypeOptions = ref([])
const typeMap = ref({})

const accountInfo = ref('')
const smsContent = ref('')
const remark = ref('')
const sendTime = ref('')
const anonymous = ref(true)
const name = ref('')
const form = ref({ phone: '', code: '' })

const show = ref(false)
const currentDate = ref(dayjs().add(2, 'm').toDate())
const minDate = ref(dayjs().add(2, 'm').toDate())
const previewSms = ref(false)
const previewDate = ref('')
const isBindPhone = ref(false)
const showTermsDialog = ref(true)
const showBindPhoneDialog = ref(false)
const showZYSXTips = ref(false)
const isPay = ref(false)
const orderId = ref('')
const submitType = ref('submit')

const isSmsSend = ref(false)
const sendBtnText = ref('发送验证码')
const timer = ref(null)
const counter = ref(60)

// 动态计算选中的标题
const selectedText = computed(() => {
  if (!msgType.value) return '请选择社交软件'
  const item = msgTypeOptions.value.find(o => o.value === msgType.value)
  return item ? item.text : '请选择社交软件'
})

const getMsgTypeData = async () => {
  const res = await getMsgType()
  if (res.data.code === '00000') {
    const list = res.data.data
    typeMap.value = {}
    msgTypeOptions.value = list.map(item => {
      typeMap.value[item.msgType] = item
      return { text: item.name, value: item.msgType }
    })
  }
}

const currentType = computed(() => typeMap.value[msgType.value] || {})
const maxLength = computed(() => currentType.value.maxLength || 5000)
const currentPrice = computed(() => currentType.value.price || '9.90')

const getSelectedMsgTypeId = () => currentType.value.id || ''

// 提交校验
const submit = () => {
  if (!msgType.value) {
    Toast('请先选择社交软件')
    return
  }
  if (!isBindPhone.value) {
    // 打开绑定弹窗
    showBindPhoneDialog.value = true
    return
  }
  if (smsContent.value.length > maxLength.value){
    Toast('发送内容超过最大限制')
    return
  }
  if (submitType.value === 'submit') {
    createOrder()
  }
}

const createOrder = async () => {
  const msgTypeId = getSelectedMsgTypeId()
  const params = {
    accountInfo: accountInfo.value,
    content: smsContent.value,
    sendTime: sendTime.value,
    sendName: name.value,
    userRemark: remark.value,
    isChat: false,
    msgType: msgTypeId
  }
  const res = await createMessengerOrder(params)
  if (res.data.code === '00000') {
    orderId.value = res.data.data.orderId
    pay(res.data.data)
  }
}

const pay = (data) => {
  wx.chooseWXPay({
    appId: data.appId,
    timestamp: data.timeStamp,
    nonceStr: data.nonceStr,
    package: data.packageValue,
    signType: data.signType,
    paySign: data.paySign,
    success: () => {
      isPay.value = true
      Toast.success('创建成功')
    },
    cancel: () => {
      isPay.value = false
    },
    fail: () => {
      isPay.value = false
    }
  })
}

const submitTime = (val) => {
  currentDate.value = val
  sendTime.value = dayjs(val).format('YYYY-MM-DD HH:mm')
  show.value = false
}
const showTimePopup = () => {
  show.value = true
}

// 绑定成功
const handleBindSuccess = () => {
  isBindPhone.value = true;
  showBindPhoneDialog.value = false;
};

// 关闭绑定
const handleBindClose = () => {
  showBindPhoneDialog.value = false;
};


const onClickLeft = () => {
  router.push('/index')
}



onMounted(async () => {
  await getMsgTypeData()
  try {
    const res = await getUserInfo()
    if (res.data.code === '00000') {
      isBindPhone.value = !!(res.data.data.phone && res.data.data.phone !== '')
    }
  } catch (e) {
    console.log('获取用户信息失败')
  }

  // 微信配置
  const url = { url: window.location.href }
  const res = await getJsAPiSign(url)
  wx.config({
    debug: false,
    appId: res.data.data.appId,
    timestamp: res.data.data.timestamp,
    nonceStr: res.data.data.nonceStr,
    signature: res.data.data.signature,
    jsApiList: ['chooseWXPay'],
    openTagList: ['wx-open-launch-weapp']
  })
})

onBeforeUnmount(() => {
  Toast.clear()
  clearInterval(timer.value)
})
</script>

<style scoped>
:deep(.van-dropdown-menu__item) {
  display: flex !important;
  justify-content: space-between !important;
  text-align: left !important;
  align-items: center !important;
  width: 100% !important;
}
:deep(.van-dropdown-item__title) {
  display: flex !important;
  justify-content: space-between !important;
  width: 100% !important;
  text-align: left !important;
}
:deep(.van-dropdown-item__text) {
  flex: 1 !important;
  text-align: left !important;
}
:deep(.van-dropdown-item__arrow) {
  margin-left: auto !important;
}

.van-nav-bar {
  --van-nav-bar-icon-color: #292833;
  --van-nav-bar-text-color: #292833;
  background-color: #f7f7f7;
}

.main {
  min-height: 100vh;
  /* 关键修改：让背景覆盖整个页面 */
  height: auto;
  background-color: #f7f7f7;
  /* 可选：防止某些浏览器背景截断 */
  overflow: visible;
}

.item {
  margin-top: 15px;
  box-sizing: border-box;
}

.form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 15px;
  margin-top: 15px;
  background-color: #f7f7f7;
}

.anonymous-line {
  min-height: 45px;
}

.name-input {
  width: 150px;
}

.name-input-field {
  background-color: #f7f7f7;
}

.sms-content {
  min-height: 180px;
  background: url('../../assets/image/02.png') right 15px bottom 15px no-repeat;
  background-size: 120px 120px;
}

.submit-btn {
  align-items: center;
  width: 160px;
  margin-bottom: 20px;
}

.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 15px;
  padding-top: 15px;
  background-color: #f7f7f7;
  box-sizing: border-box;
}

.center-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  background-color: #f7f7f7;
}

.sms-price-explain {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  font-size: 12px;
  height: 30px;
  background: #f7f7f7;
  margin-top: 5px;
}

.preview-date {
  font-size: 14px;
}

.preview-box {
  min-height: 80px;
  background: white;
  border-radius: 15px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 15px;
}

.preview-box-from {
  color: #e6e6e6;
  font-size: 16px;
}

.preview-box-item {
  color: #292833;
  line-height: 20px;
  margin-top: 10px;
  font-size: 14px;
}

.phone-tips {
  font-size: 13px;
  margin: 15px;
  color: #9ca3af;
}

.zysx-tips-content {
  padding: 0 16px 10px;
  font-size: 14px;
  color: #333;
}

.zysx-item {
  margin-bottom: 14px;
  line-height: 1.6;
}

.zysx-question {
  color: black;
  font-weight: bold;
  margin: 1px 0;
}

.zysx-desc {
  color: #666;
  margin-top: 3px;
  padding-left: 4px;
}
</style>